export function useShowMe() {
    const handleShowMe = () =>{
        return location.pathname != "/nfe/issuer"
    }
    return handleShowMe
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Footer/hooks/index.js